<template>
    <el-container style="height: 100%" v-loading="loading">
        <el-aside width="200px" style="height: 100%;background-color: var(--el-fill-color-darker)">
            <el-scrollbar>
                <div class="aside-group">
                    <div style="display: flex;justify-content: space-between">
                        <b>主要标签</b>
                        <div style="display: flex; gap: 5px;">
                            <el-icon @click.stop="createTag('major', {id: null, name: '根节点'})" v-if="major_editing">
                                <Plus style="cursor: pointer; font-size: 16px;" />
                            </el-icon>
                            <el-button type="success" text size="small" v-if="major_editing"
                                       @click="major_editing=false">
                                完成
                            </el-button>
                            <el-button type="info" text size="small" v-else @click="major_editing=true">编辑</el-button>
                        </div>
                    </div>
                    <el-tree :data="major_tags" node-key="id" show-checkbox ref="major"
                             @check-change="checkChange" :expand-on-click-node="false" check-on-click-node>
                        <template #default="{node, data}">
                            <div class="tree-node">
                                <span>{{ data.name }}</span>
                                <el-icon @click.stop="createTag('major', data)" v-if="major_editing">
                                    <Plus/>
                                </el-icon>
                                <span v-else>{{ data.images ? data.images.length : 0 }}</span>
                            </div>
                        </template>
                    </el-tree>
                </div>
                <div class="aside-group">
                    <div style="display: flex;justify-content: space-between">
                        <b>次要标签</b>
                        <div style="display: flex; gap: 5px;">
                            <el-icon @click.stop="createTag('minor', {id: null, name: '根节点'})" v-if="minor_editing">
                                <Plus style="cursor: pointer; font-size: 16px;" />
                            </el-icon>
                            <el-button type="success" text size="small" v-if="minor_editing"
                                       @click="minor_editing=false">
                                完成
                            </el-button>
                            <el-button type="info" text size="small" v-else @click="minor_editing=true">编辑</el-button>
                        </div>
                    </div>
                    <el-tree :data="minor_tags" node-key="id" show-checkbox ref="minor"
                             @check-change="checkChange" :expand-on-click-node="false" check-on-click-node>
                        <template #default="{node, data}">
                            <div class="tree-node">
                                <span>{{ data.name }}</span>
                                <el-icon @click.stop="createTag('minor', data)" v-if="minor_editing">
                                    <Plus/>
                                </el-icon>
                                <span v-else>{{ data.images ? data.images.length : 0 }}</span>
                            </div>
                        </template>
                    </el-tree>
                </div>
                <div class="aside-group">
                    <div style="display: flex;justify-content: space-between">
                        <b>辅助标签</b>
                        <div style="display: flex; gap: 5px;">
                            <el-icon @click.stop="createTag('assistant', {id: null, name: '根节点'})" v-if="assistant_editing">
                                <Plus style="cursor: pointer; font-size: 16px;" />
                            </el-icon>
                            <el-button type="success" text size="small" v-if="assistant_editing" @click="assistant_editing=false">
                                完成
                            </el-button>
                            <el-button type="info" text size="small" v-else @click="assistant_editing=true">编辑</el-button>
                        </div>
                    </div>
                    <el-tree :data="assistant_tags" node-key="id" show-checkbox ref="assistant"
                             @check-change="checkChange" :expand-on-click-node="false" check-on-click-node>
                        <template #default="{node, data}">
                            <div class="tree-node">
                                <span>{{ data.name }}</span>
                                <el-icon @click.stop="createTag('assistant', data)" v-if="assistant_editing">
                                    <Plus/>
                                </el-icon>
                                <span v-else>{{ data.images ? data.images.length : 0 }}</span>
                            </div>
                        </template>
                    </el-tree>
                </div>

            </el-scrollbar>
        </el-aside>
        <el-main style="height: 100%;padding: 0">
            <el-container style="height: 100%">
                <el-header height="auto" class="tag-toolbar">
                    <div class="tag-toolbar-actions">
                        <el-radio-group v-model="ai_workflow_filter" size="small" @change="onFilterChange">
                            <el-radio-button label="all">全部图片</el-radio-button>
                            <el-radio-button label="needs_tag">待打标</el-radio-button>
                            <el-radio-button label="review">待审核</el-radio-button>
                        </el-radio-group>
                        <el-checkbox v-model="reviewAttentionOnly" @change="onFilterChange">需重点审核</el-checkbox>
                        <el-checkbox v-model="showOnline" @change="onFilterChange">已上线</el-checkbox>
                        <el-checkbox v-model="showOffline" @change="onFilterChange">未上线</el-checkbox>
                        <el-button size="small" plain @click="togglePageSelection">{{ allPageSelected ? '取消本页' : '选择本页' }}</el-button>
                        <el-button size="small" plain :disabled="!selected_ids.length" @click="clearSelection">清空选择</el-button>
                        <span v-if="selected_ids.length">已选 {{ selected_ids.length }} 张</span>
                        <el-button size="small" type="success"
                                   :disabled="!selectedNeedsAiImages.length || isAiJobRunning || ai_confirming"
                                   @click="aiTagSelectedImages(false)">生成选中建议</el-button>
                        <el-button size="small" type="primary" plain
                                   :disabled="!selectedPendingAiImages.length || isAiJobRunning || ai_confirming"
                                   @click="confirmSelectedAiTags">接受选中</el-button>
                        <el-button size="small" type="danger"
                                   :disabled="!selectedPendingAiImages.length || isAiJobRunning || ai_confirming"
                                   @click="rejectSelectedAiTags">驳回选中</el-button>
                        <el-button size="small" type="danger" plain
                                   :disabled="!pendingAiImages.length || isAiJobRunning || ai_confirming"
                                   @click="rejectPageAiTags">驳回本页</el-button>
                        <el-button size="small" type="warning" plain
                                   :disabled="isAiJobRunning || ai_confirming"
                                   @click="batchSetSource('ky')">标记 ky</el-button>
                        <el-button size="small" type="warning" plain
                                   :disabled="isAiJobRunning || ai_confirming"
                                   @click="batchSetSource('ai')">标记 ai</el-button>
                        <el-dropdown trigger="click" @command="handleAiSettingsCommand" :disabled="isAiJobRunning || ai_confirming">
                            <el-button size="small" plain>更多</el-button>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item command="retag_selected" :disabled="!selected_ids.length">重新打标选中图片</el-dropdown-item>
                                    <el-dropdown-item command="vocabulary">AI 词表设置</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                        <span v-if="ai_job && ['pending', 'running'].includes(ai_job.status)" style="color: var(--el-color-warning)">
                            AI 打标签中 {{ ai_job.done }}/{{ ai_job.total }}，成功 {{ ai_job.success }}，失败 {{ ai_job.failed }}
                            <template v-if="ai_job.status_message">，{{ ai_job.status_message }}</template>
                        </span>
                    </div>
                    <el-input v-model="query" placeholder="ID搜索" size="small"
                              style="width: 200px;margin: 6px"></el-input>
                </el-header>
                <el-main style="height: 100%;padding: 10px">
                    <el-scrollbar>
                        <div style="display: flex;flex-wrap: wrap">
                            <el-card :body-style="{padding: 0}" shadow="hover" v-for="d in dataPage" :key="d.id"
                                     style="margin: 10px;height: 420px;width: 240px;font-size: 12px">
                                <el-image class="card-media" lazy :src="resourceUrl(d.thumbnail)"></el-image>
                                <video v-if="isVideoResource(d.animation || d.resource)" class="card-media" controls muted playsinline
                                       :src="resourceUrl(d.animation || d.resource)"></video>
                                <el-image v-else class="card-media" lazy :src="resourceUrl(d.resource)"></el-image>
                                <div style="padding: 10px;line-height: 34px;height: 270px;overflow-y: auto;-ms-overflow-style: none;scrollbar-width: none;">
                                    <el-row style="display: flex;justify-content: space-between">
                                        <span>
                                            <el-checkbox :model-value="isSelected(d.id)" @change="checked => toggleSelect(d.id, checked)"></el-checkbox>
                                            ID: {{ d.id }}
                                        </span>
                                        <el-select v-model="d.source" size="small" style="width: 100px;margin: 3px 0"
                                                   allow-create filterable placeholder="来源" :disabled="loading"
                                                   @change="update(d)">
                                            <el-option v-for="s in source_list" :value="s"></el-option>
                                        </el-select>
                                    </el-row>
                                    <el-row style="display: flex;justify-content: space-between">
                                        <span>上线时间：{{ d.online_date || '未上线' }}</span>
                                    </el-row>
                                    <ai-tag-review-summary :image="d" :maps="{categories: category_map, major_tags: major_map, minor_tags: minor_map, assistant_tags: assistant_map}" />
                                    <el-row style="line-height: 24px; margin-top: 5px">分类：
                                        <el-select size="small" v-model="d.categories" @change="updateTags(d)"
                                                   filterable style="width: 180px" multiple :disabled="loading">
                                            <el-option v-for="c in category_list" :label="c.i18n_name.ZH_HANS"
                                                       :value="c.id"></el-option>
                                        </el-select>
                                        <el-tag v-for="t in aiPreviewTags(d, 'categories')" :key="`ai-category-${t}`"
                                                type="warning" effect="plain" :closable="!d.ai_confirming"
                                                @close="removeAiTag(d, 'categories', t)">
                                            AI: {{ category_map[t] || t }}
                                        </el-tag>
                                        <el-tag v-if="aiAbstained(d, 'categories')" type="info" effect="plain">AI: 待人工</el-tag>
                                    </el-row>
                                     <el-row style="line-height: 24px; margin-top: 5px">主要标签：
                                         <el-tag v-for="t in d.major_tags" :closable="!loading"
                                                 @close="removeTag(d, 'major_tags', t)">{{ major_map[t] || t }}
                                         </el-tag>
                                         <el-tag v-for="t in aiPreviewTags(d, 'major_tags')" :key="`ai-major-${t}`"
                                                 type="warning" effect="plain" :closable="!d.ai_confirming"
                                                 @close="removeAiTag(d, 'major_tags', t)">
                                             AI: {{ major_map[t] || t }}
                                         </el-tag>
                                         <el-tag v-if="aiAbstained(d, 'major_tags')" type="info" effect="plain">AI: 待人工</el-tag>
                                        <el-popover trigger="click" :teleported="false"
                                                    v-if="d.ai_tag_result_id || !d.major_tags || d.major_tags.length < 1">
                                            <el-cascader size="small" :options="major_tags" filterable
                                                         :props="{expandTrigger: 'hover', label: 'name', value: 'id', children: 'children'}"
                                                         @change="addTag($event, d, 'major_tags')"></el-cascader>
                                            <template #reference>
                                                <el-button size="small" type="primary" text>添加
                                                </el-button>
                                            </template>
                                        </el-popover>
                                     </el-row>
                                     <el-row style="line-height: 24px; margin-top: 5px">次要标签：
                                         <el-tag v-for="t in d.minor_tags" :closable="!loading"
                                                 @close="removeTag(d, 'minor_tags', t)">{{ minor_map[t] || t }}
                                        </el-tag>
                                        <el-tag v-for="t in aiPreviewTags(d, 'minor_tags')" :key="`ai-minor-${t}`"
                                                type="warning" effect="plain" :closable="!d.ai_confirming"
                                                @close="removeAiTag(d, 'minor_tags', t)">
                                            AI: {{ minor_map[t] || t }}
                                        </el-tag>
                                        <el-tag v-if="aiAbstained(d, 'minor_tags')" type="info" effect="plain">AI: 待人工</el-tag>
                                        <el-popover trigger="click" :teleported="false">
                                            <el-cascader size="small" :options="minor_tags" filterable
                                                         :props="{expandTrigger: 'hover', label: 'name', value: 'id', children: 'children'}"
                                                         @change="addTag($event, d, 'minor_tags')"></el-cascader>
                                            <template #reference>
                                                <el-button size="small" type="primary" text>添加
                                                </el-button>
                                            </template>
                                        </el-popover>
                                     </el-row>
                                     <el-row style="line-height: 24px; margin-top: 5px">辅助标签：
                                         <el-tag v-for="t in d.assistant_tags" :closable="!loading"
                                                 @close="removeTag(d, 'assistant_tags', t)">{{ assistant_map[t] || t }}
                                        </el-tag>
                                        <el-tag v-for="t in aiPreviewTags(d, 'assistant_tags')" :key="`ai-assistant-${t}`"
                                                type="warning" effect="plain" :closable="!d.ai_confirming"
                                                @close="removeAiTag(d, 'assistant_tags', t)">
                                            AI: {{ assistant_map[t] || t }}
                                        </el-tag>
                                        <el-tag v-if="aiAbstained(d, 'assistant_tags')" type="info" effect="plain">AI: 待人工</el-tag>
                                        <el-popover trigger="click" :teleported="false">
                                            <el-cascader size="small" :options="assistant_tags" filterable
                                                         :props="{expandTrigger: 'hover', label: 'name', value: 'id', children: 'children'}"
                                                         @change="addTag($event, d, 'assistant_tags')"></el-cascader>
                                            <template #reference>
                                                <el-button size="small" type="primary" text>添加
                                                </el-button>
                                            </template>
                                        </el-popover>
                                     </el-row>
                                     <el-row style="margin-top: 8px; display: flex; gap: 5px;">
                                         <el-button size="small" type="success" plain :disabled="loading || isAiJobRunning" @click="aiTagSingleImage(d)">{{ needsAiTag(d) ? '生成建议' : '重新生成' }}</el-button>
                                         <el-button v-if="d.ai_tag_result_id" size="small" type="primary" :disabled="d.ai_confirming" @click="confirmSingleAiTag(d)">接受全部</el-button>
                                         <el-button v-if="d.ai_tag_result_id" size="small" type="danger" plain :disabled="d.ai_confirming" @click="rejectSingleAiTag(d)">驳回全部</el-button>
                                         <el-button size="small" type="warning" plain :disabled="d.ai_confirming" @click="openAiFeedback(d)">反馈</el-button>
                                     </el-row>
                                </div>
                            </el-card>
                        </div>
                    </el-scrollbar>
                </el-main>
                <el-footer style="text-align: center" height="40px">
                    <el-pagination v-model:current-page="page" :page-size="size" layout="prev, pager, next"
                                   :total="dataFilter.length"></el-pagination>
                </el-footer>
            </el-container>
        </el-main>
        <ai-vocabulary-dialog v-model="ai_vocabulary_visible" />
        <ai-tag-feedback-dialog v-model="ai_feedback_visible" :image="ai_feedback_image" />
    </el-container>
</template>

<script>
import axios from "ts-axios-new";
import {ElMessage, ElMessageBox} from 'element-plus'
import AiVocabularyDialog from './AiVocabularyDialog.vue';
import AiTagFeedbackDialog from './AiTagFeedbackDialog.vue';
import AiTagReviewSummary from './AiTagReviewSummary.vue';
import {
    aiReviewReasons,
    editAiSuggestionFields,
    filterAiWorkflowImages,
    imageIdsToRefreshAfterJob,
    needsAiTag as imageNeedsAiTag,
    pendingReviewImages,
    selectedNeedsTagImages,
    selectedPendingReviewImages,
} from '../libs/aiTagWorkflow.mjs';

const CDN_URL = import.meta.env.VITE_CDN_URL || 'https://jigsaw-cdn.plutodesk.com';

export default {
    name: "Tag",
    components: {AiVocabularyDialog, AiTagFeedbackDialog, AiTagReviewSummary},
    data() {
        return {
            loading: false, data: [], major_tags: [], minor_tags: [], assistant_tags: [], category_list: [], image_list: [],
            major_map: {}, minor_map: {}, assistant_map: {}, category_map: {},

            reviewAttentionOnly: false, showOnline: false, showOffline: false, sort: 'online', order: 'desc', page: 1, size: 20,
            major_keys: [], minor_keys: [], assistant_keys: [],
            major_editing: false, minor_editing: false, assistant_editing: false,
            query: '',
            source_list: [],
            selected_ids: [],
            ai_job: null,
            ai_job_image_ids: [],
            ai_job_timer: null,
            ai_job_poll_failures: 0,
            ai_job_polling: false,
            ai_confirming: false,
            ai_workflow_filter: 'all',
            ai_destroyed: false,
            ai_vocabulary_visible: false,
            ai_feedback_visible: false,
            ai_feedback_image: null,
        }
    },
    methods: {
        resourceUrl(resource) {
            if (!resource) return '';
            if (/^https?:\/\//.test(resource)) {
                return resource;
            }
            return `${CDN_URL}/${resource}`;
        },
        isVideoResource(resource) {
            return !!resource && /\.mp4($|\?)/i.test(resource);
        },
        init() {
            this.loading = true;
            let majorTags = [];
            let minorTags = [];
            let assistantTags = [];
            
            axios.all([
                axios.get(`/cms/v1/image`, {params: {limit: 10000}}).then(res => {
                    this.image_list = res.data.data.imageList;
                }),
                axios.get(`/cms/v1/tag/major`).then(res => {
                    majorTags = res.data.data.tagList;
                    this.buildTagMap(this.major_map, majorTags);
                }),
                axios.get(`/cms/v1/tag/minor`).then(res => {
                    minorTags = res.data.data.tagList;
                    this.buildTagMap(this.minor_map, minorTags);
                }),
                axios.get(`/cms/v1/tag/assistant`).then(res => {
                    assistantTags = res.data.data.tagList;
                    this.buildTagMap(this.assistant_map, assistantTags);
                }),
                axios.get('/cms/v1/category').then(res => {
                    this.category_list = res.data.data.categoryList.filter(c => !['ALL', 'COLLECTION'].includes(c.key));
                    this.category_map = {};
                    this.category_list.forEach(c => {
                        this.category_map[c.id] = c.i18n_name.ZH_HANS;
                    });
                }),
                axios.get('/cms/v1/source').then(res => {
                    this.source_list = res.data.data.sourceList.filter(s => s);
                }),
            ]).then(_ => {
                this.data = this.image_list;
                // 使用非响应式的方式统计，避免频繁触发Vue更新
                this.data.forEach(d => {
                    // 统计主要标签
                    if (d.major_tags) {
                        d.major_tags.forEach(t => {
                            majorTags.forEach(c => {
                                this.df(c, d.id, t);
                            })
                        })
                    }
                    // 统计次要标签
                    if (d.minor_tags) {
                        d.minor_tags.forEach(t => {
                            minorTags.forEach(c => {
                                this.df(c, d.id, t);
                            })
                        })
                    }
                    // 统计辅助标签
                    if (d.assistant_tags) {
                        d.assistant_tags.forEach(t => {
                            assistantTags.forEach(c => {
                                this.df(c, d.id, t);
                            })
                        })
                    }
                })
                
                // 统计完成后一次性赋值给响应式数据
                this.major_tags = majorTags;
                this.minor_tags = minorTags;
                this.assistant_tags = assistantTags;
                this.loading = false;
            })
        },
        buildTagMap(map, tags) {
            tags.forEach(tag => {
                map[tag.id] = tag.name;
                if (tag.children && tag.children.length) {
                    this.buildTagMap(map, tag.children);
                }
            });
        },
        df(tree, id, tagId) {
            if (!tree.images) {
                tree.images = [];
            }
            if (tree.id === tagId && !tree.images.includes(id)) {
                tree.images.push(id);
                return true;
            } else if (tree.children) {
                for (let i = 0; i < tree.children.length; i++) {
                    const c = tree.children[i];
                    if (this.df(c, id, tagId)) {
                        if (!tree.images.includes(id)) {
                            tree.images.push(id);
                            return true;
                        }
                    }
                }
            }
        },
        resort(sort) {
            if (this.sort === sort) {
                if (this.order === 'desc') {
                    this.order = 'asc';
                } else {
                    this.sort = null;
                }
            } else {
                this.sort = sort;
                this.order = 'desc';
            }
        },
        checkChange() {
            if (this.loading) return;
            this.major_keys = this.$refs.major?.getCheckedKeys() || [];
            this.minor_keys = this.$refs.minor?.getCheckedKeys() || [];
            this.assistant_keys = this.$refs.assistant?.getCheckedKeys() || [];
        },
        isSelected(id) {
            return this.selected_ids.includes(id);
        },
        toggleSelect(id, checked) {
            if (checked && !this.selected_ids.includes(id)) {
                this.selected_ids.push(id);
            } else if (!checked) {
                this.selected_ids = this.selected_ids.filter(i => i !== id);
            }
        },
        togglePageSelection() {
            const ids = this.dataPage.map(d => d.id);
            if (this.allPageSelected) {
                this.selected_ids = this.selected_ids.filter(id => !ids.includes(id));
            } else {
                ids.forEach(id => {
                    if (!this.selected_ids.includes(id)) this.selected_ids.push(id);
                });
            }
        },
        clearSelection() {
            this.selected_ids = [];
        },
        refreshImages(ids) {
            const uniqueIds = [...new Set((ids || []).filter(Boolean))];
            if (!uniqueIds.length) return Promise.resolve();
            const chunks = [];
            for (let index = 0; index < uniqueIds.length; index += 200) {
                chunks.push(uniqueIds.slice(index, index + 200));
            }
            return axios.all(chunks.map(chunk => (
                axios.get('/cms/v1/image/batch', {params: {ids: chunk.join(',')}})
            ))).then(responses => {
                const imageMap = {};
                responses.forEach(res => {
                    (res.data.data.imageList || []).forEach(img => { imageMap[img.id] = img; });
                });
                this.data.forEach((img, index) => {
                    if (imageMap[img.id]) {
                        this.data[index] = {...img, ...imageMap[img.id]};
                    }
                });
            }).catch(_ => {
                ElMessage.warning('AI 结果已生成，刷新图片失败，请手动刷新页面查看');
            });
        },
        refreshVisibleImages() {
            return this.refreshImages(this.dataPage.map(d => d.id));
        },
        resumeActiveAiTagJob() {
            axios.get('/cms/v1/ai/tag/job/active').then(res => {
                if (this.ai_destroyed) return;
                const job = res.data.data.job;
                if (job && ['pending', 'running'].includes(job.status)) {
                    this.ai_job = job;
                    this.ai_job_poll_failures = 0;
                    this.pollAiTagJob();
                }
            }).catch(() => {});
        },
        copyTagFields(d) {
            return {
                categories: [...(d.categories || [])],
                major_tags: [...(d.major_tags || [])],
                minor_tags: [...(d.minor_tags || [])],
                assistant_tags: [...(d.assistant_tags || [])],
            };
        },
        restoreTagFields(d, fields) {
            Object.keys(fields).forEach(field => {
                d[field] = [...fields[field]];
            });
        },
        aiPreviewTags(d, field) {
            return d.ai_applied_fields?.[field] || [];
        },
        startAiTagJob(payload) {
            if (this.isAiJobRunning) {
                ElMessage.info('已有 AI 打标签任务正在进行');
                return;
            }
            axios.post('/cms/v1/ai/tag/job', payload).then(res => {
                if (this.ai_destroyed) return;
                this.ai_job = res.data.data.job;
                this.ai_job_image_ids = this.ai_job.reused
                    ? []
                    : imageIdsToRefreshAfterJob(payload.ids);
                this.ai_job_poll_failures = 0;
                if (this.ai_job.reused) {
                    ElMessage.info('已有 AI 打标签任务正在进行，已恢复进度');
                } else {
                    ElMessage.success('AI 打标签已开始');
                }
                this.pollAiTagJob();
            }).catch(err => {
                if (this.ai_destroyed) return;
                ElMessage.error(this.getErrorMessage(err, '启动 AI 打标签失败'));
            });
        },
        pollAiTagJob() {
            if (!this.ai_job) return;
            if (this.ai_job_timer) clearInterval(this.ai_job_timer);
            const poll = () => {
                if (this.ai_job_polling) return;
                const jobId = this.ai_job?.id;
                if (!jobId) return;
                this.ai_job_polling = true;
                axios.post(`/cms/v1/ai/tag/job/${jobId}/process`).then(res => {
                    if (this.ai_destroyed) return;
                    this.ai_job = res.data.data.job;
                    this.ai_job_poll_failures = 0;
                    if (['finished', 'failed'].includes(this.ai_job.status)) {
                        clearInterval(this.ai_job_timer);
                        this.ai_job_timer = null;
                        const finishedJob = this.ai_job;
                        if (this.ai_job.status === 'finished') {
                            const refreshIds = imageIdsToRefreshAfterJob(this.ai_job_image_ids);
                            this.showAiJobFinished(finishedJob);
                            this.clearSelection();
                            this.ai_job = null;
                            this.ai_job_image_ids = [];
                            this.ai_job_poll_failures = 0;
                            if (refreshIds.length) {
                                this.refreshImages(refreshIds);
                            } else {
                                this.init();
                            }
                        } else {
                            ElMessage.error(this.ai_job.error_message || 'AI 打标签任务失败');
                            this.ai_job = null;
                        }
                    }
                }).catch(err => {
                    if (this.ai_destroyed) return;
                    this.ai_job_poll_failures += 1;
                    if (this.ai_job_poll_failures >= 3) {
                        clearInterval(this.ai_job_timer);
                        this.ai_job_timer = null;
                        this.ai_job = null;
                        ElMessage.error('获取 AI 打标签进度失败，任务可能仍在后台执行');
                    }
                }).finally(() => {
                    this.ai_job_polling = false;
                });
            };
            poll();
            if (!this.ai_destroyed) {
                this.ai_job_timer = setInterval(poll, 3000);
            }
        },
        showAiJobFinished(job) {
            const message = `AI 打标签完成：成功 ${job.success} 张，失败 ${job.failed} 张`;
            if (!job.failed) {
                ElMessage.success(message);
                return;
            }
            ElMessageBox.alert(this.buildAiJobFailureHtml(job), message, {
                confirmButtonText: '知道了',
                dangerouslyUseHTMLString: true,
                type: 'warning',
            });
        },
        buildAiJobFailureHtml(job) {
            const failures = job.failure_samples || (job.results || []).filter(r => r.status === 'failed');
            const rows = failures.slice(0, 20).map(r => {
                const attempts = r.attempts ? `，尝试 ${r.attempts} 次` : '';
                return `<li><code>${this.escapeHtml(r.image_id || '')}</code>${attempts}<br>${this.escapeHtml(r.error_message || '未知错误')}</li>`;
            }).join('');
            const failed = job.failed || failures.length;
            const moreCount = Math.max(0, failed - failures.slice(0, 20).length);
            const more = moreCount ? `<p>还有 ${moreCount} 条失败未展示。</p>` : '';
            return `<div style="line-height: 1.6;">
                <p>下面是失败明细，方便判断是图片、接口、AI 返回还是标签匹配问题：</p>
                <ol style="padding-left: 18px;">${rows || '<li>没有失败明细</li>'}</ol>
                ${more}
            </div>`;
        },
        escapeHtml(value) {
            return String(value).replace(/[&<>"']/g, s => ({
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;',
            }[s]));
        },
        handleAiSettingsCommand(command) {
            if (command === 'vocabulary') {
                this.ai_vocabulary_visible = true;
            } else if (command === 'retag_selected') {
                this.aiTagSelectedImages(true);
            } else if (command === 'source_ky') {
                this.batchSetSource('ky');
            } else if (command === 'source_ai') {
                this.batchSetSource('ai');
            }
        },
        aiTagSingleImage(d) {
            this.startAiTagJob({ids: [d.id], overwrite: !this.needsAiTag(d)});
        },
        needsAiTag(d) {
            return imageNeedsAiTag(d);
        },
        aiTagSelectedImages(overwrite = false) {
            if (!this.selected_ids.length) {
                ElMessage.info('请先选择图片');
                return;
            }
            const ids = overwrite
                ? [...this.selected_ids]
                : this.selectedNeedsAiImages.map(image => image.id);
            if (!ids.length) {
                ElMessage.info('选中图片里没有待打标内容');
                return;
            }
            const actionText = overwrite
                ? '重新识别已有标签；AI 留空的字段会保留原值'
                : '只为缺少的字段生成建议';
            ElMessageBox.confirm(`将处理选中的 ${ids.length} 张图片，${actionText}。是否继续？`, '生成 AI 建议', {
                confirmButtonText: '开始', cancelButtonText: '取消', type: 'warning'
            }).then(() => {
                this.startAiTagJob({ids, overwrite});
            });
        },
        aiAbstained(d, field) {
            return Boolean(d.ai_tag_result_id) && this.aiPreviewTags(d, field).length === 0;
        },
        updateAiSuggestion(d, field, values, successMessage) {
            const resultId = d.ai_tag_result_id;
            if (!resultId) return;
            d.ai_confirming = true;
            axios.put(`/cms/v1/ai/tag/suggestion/${resultId}`, {field, values}).then(res => {
                d.ai_applied_fields = res.data.data.applied_fields;
                ElMessage.success(successMessage);
            }).catch(err => {
                ElMessage.error(this.getErrorMessage(err, '修改 AI 建议失败'));
            }).finally(() => {
                d.ai_confirming = false;
            });
        },
        removeAiTag(d, field, tag) {
            const values = this.aiPreviewTags(d, field).filter(value => value !== tag);
            this.updateAiSuggestion(d, field, values, '已驳回该标签');
        },
        openAiFeedback(d) {
            this.ai_feedback_image = d;
            this.ai_feedback_visible = true;
        },
        confirmSingleAiTag(d) {
            d.ai_confirming = true;
            const resultId = d.ai_tag_result_id;
            axios.put('/cms/v1/ai/tag/confirm', {ids: [resultId], action: 'confirm'}).then(res => {
                const confirmedIds = res.data.data.confirmed_ids || [];
                if (confirmedIds.includes(resultId)) {
                    this.applyAiFields(d);
                    ElMessage.success('已确认');
                } else {
                    this.clearAiFields(d);
                    ElMessage.warning('AI 结果已过期或被替换，请重新打标签');
                }
            }).catch(err => { ElMessage.error(this.getErrorMessage(err, '确认失败')); }).finally(_ => { d.ai_confirming = false });
        },
        rejectSingleAiTag(d) {
            d.ai_confirming = true;
            const resultId = d.ai_tag_result_id;
            axios.put('/cms/v1/ai/tag/confirm', {ids: [resultId], action: 'reject', reason: 'single_reject'}).then(res => {
                this.clearAiFields(d);
                const rejectedIds = res.data.data.rejected_ids || [];
                ElMessage[rejectedIds.includes(resultId) ? 'success' : 'warning'](
                    rejectedIds.includes(resultId) ? '已驳回' : 'AI 结果已过期或被替换'
                );
            }).catch(err => { ElMessage.error(this.getErrorMessage(err, '驳回失败')); }).finally(_ => { d.ai_confirming = false });
        },
        reviewAiTags(images, action, scopeLabel) {
            if (!images.length) {
                ElMessage.info('没有可审核的 AI 结果');
                return;
            }
            const isReject = action === 'reject';
            const verb = isReject ? '驳回' : '接受';
            const message = isReject
                ? `将驳回${scopeLabel} ${images.length} 条 AI 建议，不会修改正式标签。`
                : `将接受${scopeLabel} ${images.length} 条 AI 建议；AI 标记“待人工”的字段不会清空正式标签。`;
            ElMessageBox.confirm(message, `${verb} AI 建议`, {
                confirmButtonText: verb, cancelButtonText: '取消', type: isReject ? 'warning' : 'info'
            }).then(() => {
                this.ai_confirming = true;
                axios.put('/cms/v1/ai/tag/confirm', {
                    ids: images.map(d => d.ai_tag_result_id),
                    action,
                    reason: isReject ? 'batch_reject' : '',
                }).then(res => {
                    const confirmedIds = new Set(res.data.data.confirmed_ids || []);
                    const rejectedIds = new Set(res.data.data.rejected_ids || []);
                    const skippedIds = new Set(res.data.data.skipped_ids || []);
                    images.forEach(d => {
                        if (confirmedIds.has(d.ai_tag_result_id)) {
                            this.applyAiFields(d);
                        } else if (rejectedIds.has(d.ai_tag_result_id) || skippedIds.has(d.ai_tag_result_id)) {
                            this.clearAiFields(d);
                        }
                    });
                    const count = isReject ? (res.data.data.rejected || 0) : (res.data.data.confirmed || 0);
                    ElMessage.success(`已${verb} ${count} 张`);
                    this.clearSelection();
                }).catch(err => {
                    ElMessage.error(this.getErrorMessage(err, `批量${verb}失败`));
                }).finally(() => {
                    this.ai_confirming = false;
                });
            }).catch(() => {});
        },
        confirmSelectedAiTags() {
            this.reviewAiTags(this.selectedPendingAiImages, 'confirm', '选中的');
        },
        rejectSelectedAiTags() {
            this.reviewAiTags(this.selectedPendingAiImages, 'reject', '选中的');
        },
        rejectPageAiTags() {
            this.reviewAiTags(this.pendingAiImages, 'reject', '本页');
        },
        applyAiFields(d) {
            const fields = d.ai_applied_fields || {};
            ['categories', 'major_tags', 'minor_tags', 'assistant_tags'].forEach(field => {
                if (fields[field] && fields[field].length) {
                    d[field] = [...fields[field]];
                }
            });
            this.clearAiFields(d);
        },
        clearAiFields(d) {
            d.ai_tag_result_id = null;
            d.ai_applied_fields = null;
        },
        applySourceToVisibleImages(source, ids = []) {
            const selected = new Set(ids);
            this.data.forEach(d => {
                if (selected.size) {
                    if (selected.has(d.id)) d.source = source;
                } else if (!d.source) {
                    d.source = source;
                }
            });
        },
        batchSetSource(source) {
            const ids = [...this.selected_ids];
            const hasSelection = ids.length > 0;
            const message = hasSelection
                ? `将已选 ${ids.length} 张图片来源设置为 "${source}"。该操作会覆盖这些图片已有来源，是否继续？`
                : `未选择图片，将把当前产品下所有“来源为空”的图片标记为 "${source}"。已有来源的图片不会被覆盖，是否继续？`;
            ElMessageBox.confirm(message, `标记 ${source}`, {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.loading = true;
                const payload = hasSelection ? {source, ids} : {source, filters: {}};
                axios.put('/cms/v1/batch-source', payload).then(res => {
                    const count = res.data.data.affected_count || 0;
                    this.applySourceToVisibleImages(source, hasSelection ? ids : []);
                    ElMessage.success(`已标记 ${count} 张图片来源为 "${source}"`);
                    if (hasSelection) this.clearSelection();
                    this.init();
                }).catch(err => {
                    ElMessage.error(this.getErrorMessage(err, '标记失败'));
                }).finally(_ => {
                    this.loading = false;
                });
            }).catch(() => {});
        },
        createTag(tagType, parent) {
            ElMessageBox.confirm(
                `
                <div style="display: flex; flex-direction: column; gap: 12px; font-size: 14px;">
                    <div style="display: flex; align-items: center; gap: 8px;">
                        <span style="font-size: 20px; color: #f90;">⚠️</span>
                        <span>请输入要${parent.id ? `在 <strong style="color:#409eff;">「${parent.name}」</strong> 下添加` : '添加到根节点'}的标签名称：</span>
                    </div>
                    <input id="name" placeholder="请输入中文名称" style="box-sizing: border-box;  width: 100%; height: 32px; line-height: 32px; padding: 0 11px;
                        font-size: 14px; color: #606266; background-color: #fff; border: 1px solid #dcdfe6; border-radius: 4px; outline: none;
                        transition: border-color .2s cubic-bezier(.645,.045,.355,1), box-shadow .2s cubic-bezier(.645,.045,.355,1); margin-bottom: 10px;"
                        onfocus="this.style.borderColor='#409eff'; this.style.boxShadow='0 0 0 1px rgba(64,158,255,0.2)';"
                        onblur="this.style.borderColor='#dcdfe6'; this.style.boxShadow='none';"/>
                    <input id="key" placeholder="请输入英文名称" style="box-sizing: border-box;  width: 100%; height: 32px; line-height: 32px; padding: 0 11px;
                        font-size: 14px; color: #606266; background-color: #fff; border: 1px solid #dcdfe6; border-radius: 4px; outline: none;
                        transition: border-color .2s cubic-bezier(.645,.045,.355,1), box-shadow .2s cubic-bezier(.645,.045,.355,1); margin-bottom: 10px;"
                        onfocus="this.style.borderColor='#409eff'; this.style.boxShadow='0 0 0 1px rgba(64,158,255,0.2)';"
                        onblur="this.style.borderColor='#dcdfe6'; this.style.boxShadow='none';"/>
                </div>
              `,
              '创建标签',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                showCancelButton: true,
                closeOnClickModal: false,
              }
            )
            .then(() => {
                const name = document.getElementById('name').value;
                const key = document.getElementById('key').value;
                if (!name) {
                    ElMessage.error('请输入中文名称');
                    return;
                }
                if (!key) {
                    ElMessage.error('请输入英文名称');
                    return;
                }

                axios.post(`/cms/v1/tag/${tagType}`, {
                    name,
                    key,
                    parent_id: parent.id
                }).then(res => {
                    res.data.data.children = [];
                    if (parent.id) {
                        parent.children.push(res.data.data);
                    } else {
                        // 在根节点下添加新标签
                        if (tagType === 'major') {
                            this.major_tags.push(res.data.data);
                        } else if (tagType === 'minor') {
                            this.minor_tags.push(res.data.data);
                        } else if (tagType === 'assistant') {
                            this.assistant_tags.push(res.data.data);
                        }
                    }
                });
            })
            .catch(() => {});
        },
        addTag(value, d, category) {
            const tagId = value[value.length - 1];
            if (!tagId) return;
            if (d.ai_tag_result_id) {
                const current = this.aiPreviewTags(d, category);
                const fields = editAiSuggestionFields(
                    d.ai_applied_fields,
                    category,
                    [...current, tagId],
                );
                this.updateAiSuggestion(d, category, fields[category], '已添加该标签');
                return;
            }
            const previous = this.copyTagFields(d);
            if (d[category]) {
                if (!d[category].includes(tagId)) {
                    d[category].push(tagId);
                }
            } else {
                d[category] = [tagId];
            }
            this.updateTags(d, previous);
        },
        removeTag(d, category, tag) {
            const previous = this.copyTagFields(d);
            d[category].splice(d[category].indexOf(tag), 1);
            if (d[category].length === 0) {
                d[category] = [];
            }
            this.updateTags(d, previous);
        },
        updateTags(row, previous = null) {
            axios.put(`/cms/v1/image/${row.id}/tags`, this.copyTagFields(row)).then(res => {
                const data = res.data.data || res.data;
                ['categories', 'major_tags', 'minor_tags', 'assistant_tags'].forEach(field => {
                    if (Object.prototype.hasOwnProperty.call(data, field)) row[field] = data[field] || [];
                });
                this.clearAiFields(row);
            }).catch(_ => {
                axios.put(`/cms/v1/image/${row.id}`, row).catch(err => {
                    if (previous) this.restoreTagFields(row, previous);
                    ElMessage.error(this.getErrorMessage(err, '标签保存失败'));
                });
            });
        },
        update(row) {
            axios.put(`/cms/v1/image/${row.id}`, row).catch(err => {
                ElMessage.error(this.getErrorMessage(err, '保存失败'));
            });
        },
        getErrorMessage(err, fallback) {
            return err?.response?.data?.status?.message || err?.response?.data?.message || err?.message || fallback;
        },
        onFilterChange() {
            this.page = 1; // 重置页码
            this.clearSelection();
        },
    },
    mounted() {
        this.ai_destroyed = false;
        this.init();
        this.resumeActiveAiTagJob();
    },
    beforeUnmount() {
        this.ai_destroyed = true;
        if (this.ai_job_timer) clearInterval(this.ai_job_timer);
    },
    watch: {
        query() {
            this.page = 1;
            this.clearSelection();
        }
    },
    computed: {
        isAiJobRunning() {
            return this.ai_job && ['pending', 'running'].includes(this.ai_job.status);
        },
        allPageSelected() {
            const ids = this.dataPage.map(d => d.id);
            return ids.length > 0 && ids.every(id => this.selected_ids.includes(id));
        },
        pendingAiImages() {
            return pendingReviewImages(this.dataPage);
        },
        selectedPendingAiImages() {
            return selectedPendingReviewImages(this.data, this.selected_ids);
        },
        selectedNeedsAiImages() {
            return selectedNeedsTagImages(this.data, this.selected_ids);
        },
        dataFilter() {
            return filterAiWorkflowImages(this.data, this.ai_workflow_filter).filter(d => {
                if (this.reviewAttentionOnly && !aiReviewReasons(d).length) return false;
                if (this.query && !(d.id + '').includes(this.query))
                    return false;
                // 上线状态筛选
                if (this.showOnline && !d.online_date) return false;
                if (this.showOffline && d.online_date) return false;
                if (true) {
                    // 主要标签过滤
                    if (this.major_keys.length > 0) {
                        let valid = false;
                        this.major_keys.forEach(k => {
                            if (d.major_tags && d.major_tags.includes(k)) {
                                valid = true;
                            }
                        });
                        if (!valid)
                            return false;
                    }
                    // 次要标签过滤
                    if (this.minor_keys.length > 0) {
                        let valid = false;
                        this.minor_keys.forEach(k => {
                            if (d.minor_tags && d.minor_tags.includes(k)) {
                                valid = true;
                            }
                        });
                        if (!valid)
                            return false;
                    }
                    // 辅助标签过滤
                    if (this.assistant_keys.length > 0) {
                        let valid = false;
                        this.assistant_keys.forEach(k => {
                            if (d.assistant_tags && d.assistant_tags.includes(k)) {
                                valid = true;
                            }
                        });
                        if (!valid)
                            return false;
                    }

                    return true;
                }
                return false;
            });
        },
        dataPage() {
            return this.dataFilter.slice((this.page - 1) * this.size, this.page * this.size)
        }
    },
}
</script>

<style scoped>
.tag-toolbar {
    background-color: var(--el-fill-color-darker);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 6px 12px;
    flex-wrap: wrap;
}

.tag-toolbar-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    flex-wrap: wrap;
}

.aside-group {
    color: var(--el-text-color-regular);
    padding: 16px 0 8px 8px;
    font-size: 12px;
}

/* 标题栏样式优化 - 水平居中对齐 */
.aside-group > div:first-child {
    align-items: center;
    height: 24px;
}

/* 按钮组样式优化 - 水平居中对齐 */
.aside-group > div:first-child > div {
    align-items: center;
}

/* 加号图标垂直居中 */
.aside-group .el-icon {
    display: flex;
    align-items: center;
    height: 24px;
}

.el-tree {
    background-color: var(--el-fill-color-darker);
}

.tree-node {
    color: var(--el-text-color-regular);
    padding: 3px 10px 3px 0;
    font-size: 12px;
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
}

.el-tree ::v-deep(.el-tree-node__label) {
    width: 100%;
}

/* 卡片内容区域的滚动条样式 */
:deep(.el-card) {
    position: relative;
}

/* 隐藏卡片内容区域的滚动条（针对WebKit浏览器） */
:deep(.el-card > div:last-child)::-webkit-scrollbar {
    display: none;
}

.card-media {
    height: 120px;
    width: 120px;
    object-fit: cover;
}
</style>
